export function isOptimisticSessionId(
  sessionId: string | null | undefined
): boolean {
  return Boolean(
    sessionId && (sessionId === "temp-id" || sessionId.startsWith("temp-"))
  );
}

export function isConfirmedSessionId(
  sessionId: string | null | undefined
): boolean {
  return Boolean(sessionId) && !isOptimisticSessionId(sessionId);
}
